import React, { useState } from 'react';
import PipelineBoard from '../components/opportunities/PipelineBoard';
import AddOpportunityModal from '../components/opportunities/AddOpportunityModal';
import ImportCsvModal from '../components/common/ImportCsvModal';
import { LuPlus } from 'react-icons/lu';

const Opportunities = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCreate = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Opportunities</h2>
          <p className="mt-1 text-sm text-gray-600">
            Manage your sales pipeline and track opportunity stages
          </p>
        </div>
        <div className="flex space-x-3">
          <button
            onClick={() => setIsImportModalOpen(true)}
            className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <LuPlus className="h-4 w-4" />
            <span>Import Leads</span>
          </button>
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <LuPlus className="h-4 w-4" />
            <span>Add Opportunity</span>
          </button>
        </div>
      </div>

      <PipelineBoard key={refreshTrigger} />

      <AddOpportunityModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleCreate}
      />

      <ImportCsvModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        entityType="leads"
        onImportComplete={() => {
          handleCreate(); // Trigger refresh
        }}
      />
    </div>
  );
};

export default Opportunities;